// extracted by mini-css-extract-plugin
export default {"container":"HomeSectionContent_container__dwSMK","title":"HomeSectionContent_title__BbY0Q","description":"HomeSectionContent_description__k2QEF"};